export default "__VITE_ASSET__c4e8141a__"